export default __webpack_public_path__ + "static/media/icons8-facebook.7993d1e4.svg";